/* Structural layout only — colors come from Astryx design tokens (resolved
   inside the <Theme> scope this component renders).

   `url()` is left for the Rails asset pipeline: esbuild is told to treat
   image paths as external (see `--external:*.jpg` in package.json), so the
   reference survives into the bundled CSS, where Propshaft rewrites it to the
   digested /assets path. Logical filename, no directory — same as any Rails
   stylesheet. */

/* A near-opaque scrim in the theme's own page colour sits over the image, so
   it reads as a faint texture rather than a photo and follows the theme into
   light mode. */
.backdrop {
  position: relative;
  min-height: 100vh;
  background-color: var(--color-background-body);
  background-image: url("chrome-wave.jpg");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.backdrop::before {
  content: "";
  position: absolute;
  inset: 0;
  z-index: 0;
  background: color-mix(in srgb, var(--color-background-body) 88%, transparent);
}

.layout {
  position: relative;
  z-index: 1;
  min-height: 100vh;
  padding: var(--spacing-8);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--color-text-primary);
  font-family: var(--font-family-body);
}

/* Flex items won't shrink below their content by default, which would push a
   fixed-width card straight through the padding on a phone. The margin reset
   covers a <form> wrapped around the card, which would otherwise offset it. */
.layout > * {
  min-width: 0;
  margin: 0;
}

@media (max-width: 480px) {
  .layout {
    padding: var(--spacing-4);
  }
}
